import React from 'react';
import Icon from './Icon';

const UnderConstructionIcon = (props) => (
    <Icon {...props}>
        <path d="M6 10h4v6H6zM14 10h4v6h-4zM8 16h8v2H8zM10 8v2M14 8v2M12 8v-2" strokeLinecap="round" strokeLinejoin="round" />
    </Icon>
);

export default UnderConstructionIcon;